export const environment = {
  production: true,
  environment_name: 'production',

  // Server URL
  api_url: 'https://api.almanjobs.com',

  // CMS URL
  cms_url: 'https://cms.almanjobs.com/api',

  // Application URL
  base_url: 'https://almanjobs.com',

  enableReduxDevTools: false,
  enableTraceInReduxDevTools: false,

};
